module.exports = __webpack_public_path__ + "img/Andorra.4c84c45a.png";